import { render, staticRenderFns } from "./ModalToCRMAnalysis.vue?vue&type=template&id=5b80edbc&"
import script from "./ModalToCRMAnalysis.vue?vue&type=script&lang=js&"
export * from "./ModalToCRMAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./ModalToCRMAnalysis.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VDialog,VIcon})
